import { VIVATICKET_URL } from '../constants';

type VivaticketParamValue =
  | string
  | number
  | null
  | undefined
  | {
      value: string | number | undefined | null;
      joiner?: string;
      equater?: string;
    };

type VivaticketParams = Record<string, VivaticketParamValue>;

/** ShoID = eventId, PerIndex = eventTimeId, VenID = venueShorthand (from XML/API) */
export type WaitlistIds = {
  eventId: string;
  eventTimeId: string;
  venueShorthand: string;
};

type VivaticketUrl = {
  params: VivaticketParams | VivaticketParams[];
  type?: 'purchase' | 'waitlist';
  /** When type is 'waitlist', used to build QL per Vivaticket spec: S{ShoID}|P{PerIndex}|V{VenID}|G~/WEBPAGES/ENTAWebEvent/EventWaitingList.aspx */
  waitlistIds?: WaitlistIds;
};

const WAITLIST_QL_PATH = 'G~/WEBPAGES/ENTAWebEvent/EventWaitingList.aspx';

export const useVivaticketUrl = ({
  params,
  type = 'purchase',
  waitlistIds,
}: VivaticketUrl): string => {
  const baseUrl = VIVATICKET_URL ?? '';

  if (type === 'waitlist' && waitlistIds) {
    const { eventId, eventTimeId, venueShorthand } = waitlistIds;
    const qlSegment = `S${eventId}|P${eventTimeId}|V${venueShorthand}`;
    const ql = `${encodeURIComponent(qlSegment)}|${WAITLIST_QL_PATH}`;
    return `${baseUrl}?E=N&QL=${ql}`;
  }

  const formatParams = (paramObj: VivaticketParams): string => {
    return Object.entries(paramObj)
      .filter(([_, v]) => v !== undefined && v !== null)
      .map(([key, raw]) => {
        if (typeof raw === 'object' && raw !== null && 'value' in raw) {
          return {
            str: `${key}${raw.equater ?? '='}${encodeURIComponent(String(raw.value))}`,
            joiner: raw.joiner ?? '&',
          };
        }
        return { str: `${key}=${encodeURIComponent(String(raw))}`, joiner: '&' };
      })
      .reduce((acc, curr, idx, arr) => {
        return acc + curr.str + (idx < arr.length - 1 ? curr.joiner : '');
      }, '');
  };

  const paramString = Array.isArray(params)
    ? params.map(formatParams).join('&')
    : formatParams(params);

  const suffix = 'EntaWebHtmlSeatPlan/HtmlSeatPlan.aspx';
  return `${baseUrl}?${paramString}|G~/WEBPAGES/${suffix}`;
};
